<div class="reactions-list-container flex flex-row flex-end-center">
  <div
    #originOverlay="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="reactions-list flex flex-row flex-start-center"
    data-test-id="reactions-list"
  >
    @for (reaction of getTopThreeReactions(); track reaction) {
      <div class="reactions-list-item">
        <img
          alt="{{ reaction }}"
          attr.data-test-id="reactions-list-item-img-{{ reaction?.toLowerCase() }}"
          class="reactions-list-item-icon {{ reaction?.toLowerCase() }}"
          src="assets/images/reactions/{{ reaction?.toLowerCase() }}-bg.svg"
        />
      </div>
    }
    @if (reactions?.length > 0) {
      <div class="reactions-list-item reactions-list-counter">
        {{ reactions?.length }}
      </div>
    }
  </div>
</div>

<ng-template
  [cdkConnectedOverlayOffsetY]="-10"
  [cdkConnectedOverlayOpen]="isPanelVisible"
  [cdkConnectedOverlayOrigin]="originOverlay"
  [cdkConnectedOverlayPositions]="cdkOverlayPositions"
  #reactionsListPanel
  cdkConnectedOverlay
>
  <div class="reactions-list-menu-container">
    <div class="reactions-list-menu" data-test-id="reactions-list-menu">
      <ul class="flex flex-row flex-start-center gap-12">
        @for (reaction of getReactionsCounter(); track reaction) {
          <li class="flex flex-row flex-start-center gap-6">
            <div class="flex flex-col flex-between-center reaction-item">
              <img
                alt="{{ reaction.type }}"
                attr.data-test-id="reactions-list-menu-item-img-{{ reaction.type?.toLowerCase() }}"
                class="reaction {{ reaction.type?.toLowerCase() }}"
                src="assets/images/reactions/{{ reaction.type?.toLowerCase() }}-bg.svg"
              />
            </div>
            <div class="reaction-item-counter">
              {{ reaction.count }}
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
</ng-template>
